import { dataIdByName } from '../../const/const-params';

export const getTestId = (paramName: string) => {
  return dataIdByName[paramName] || null;
};
